import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { take } from 'rxjs';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { IContract } from 'src/app/domain/registration/models/IContract';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { ContractsListDialogComponent } from '../../contracts/components/contract-dialog/contract-list-modal/contracts-list-dialog.component';
import { ContractsService } from '../../contracts/crud-service';
import {
  contractStatusLabel,
  formatCustomerRecordDate,
} from '../customer-related/customer-related.util';

@Component({
  selector: 'app-customer-contracts-panel',
  templateUrl: './customer-contracts-panel.component.html',
  styleUrls: ['./customer-contracts-panel.component.sass'],
})
export class CustomerContractsPanelComponent implements OnChanges {
  @Input() customer: any;
  @Input() typeCes: TypeCesEnum = TypeCesEnum.NEW;

  contracts: IContract[] = [];
  loading = false;
  displayedColumns = ['code', 'status', 'updatedAt'];

  constructor(
    private contractsService: ContractsService,
    private dialog: MatDialog,
    private toastService: ToastService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customer']) {
      this.load();
    }
  }

  load(): void {
    const customerId = this.customer?.id;
    if (!customerId) {
      this.contracts = [];
      this.loading = false;
      return;
    }
    this.loading = true;
    this.contractsService
      .getContractsByCustomer(customerId)
      .pipe(take(1))
      .subscribe({
        next: (contracts) => {
          this.contracts = Array.isArray(contracts) ? contracts : [];
          this.loading = false;
        },
        error: () => {
          this.contracts = [];
          this.loading = false;
          this.toastService.showWarn('Não foi possível carregar os contratos deste cliente.');
        },
      });
  }

  statusLabel(contract: IContract): string {
    return contractStatusLabel(contract);
  }

  updatedAt(contract: IContract): string {
    return formatCustomerRecordDate(contract?.updatedAt || contract?.createdAt);
  }

  code(contract: IContract): string {
    return contract?.id ? String(contract.id) : '-';
  }

  openManager(): void {
    if (!this.customer?.id) return;
    const ref = this.dialog.open(ContractsListDialogComponent, {
      width: '80%',
      data: {
        type: 'customer',
        showNewContractButton: this.typeCes !== TypeCesEnum.SHOW,
        entityInfo: {
          id: this.customer.id,
          name: this.customer.name || this.customer.companyName,
          document: this.customer.cpf || this.customer.cnpj,
          email: this.customer.email,
          phone: this.customer.phone || this.customer.cellPhone,
        },
      },
    });
    ref.afterClosed().pipe(take(1)).subscribe(() => this.load());
  }
}
